document.documentElement.classList.remove('no-js');
document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-nav]');
    if (menu) menu.classList.toggle('is-open');
  }
  const qtyBtn = e.target.closest('[data-qty]');
  if (qtyBtn) {
    const wrap = qtyBtn.closest('.qty');
    const input = wrap && wrap.querySelector('input[type="number"]');
    if (!input) return;
    const delta = qtyBtn.dataset.qty === 'plus' ? 1 : -1;
    input.value = Math.max(1, Number(input.value || 1) + delta);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
});
